export const SELECT_TAB_ROLE = 'syftacp/SELECT_TAB_ROLE' as const
export const SELECT_TAB_VENUE = 'syftacp/SELECT_TAB_VENUE' as const
export const SELECT_TAB_AREA = 'syftacp/SELECT_TAB_AREA' as const
export const RESET_ALL_TABS = 'syftacp/RESET_ALL_TABS' as const
